@if (isAuthenticated()) {
  <div class="menu">
    <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/home"><span>{{'global.sidenavMenu.home' | translate}}</span></div>
    <!-- Cases -->
    @if (accountRoleService.isCasesActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/cases" (click)="resetFilterRequest()">{{'global.sidenavMenu.cases.main' | translate}}</div>
    }
    <div class="menu-sub" [style.display]="isCasesRouteActive() ? 'block' : 'none'">
      @if (canViewTravelCases()) {
        <div class="menu-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/cases/travel">{{'global.sidenavMenu.cases.travel' | translate}}</div>
      }
      @if (canViewMobilityCases()) {
        <div class="menu-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/cases/mobility">{{'global.sidenavMenu.cases.mobility' | translate}}</div>
      }
    </div>
    <!-- Insights -->
    @if (accountRoleService.isInsightsActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/insights">{{'global.sidenavMenu.insights.main' | translate}}</div>
    }
    <div class="menu-sub" [style.display]="isInsightsRouteActive() ? 'block' : 'none'">
      <!-- TravelCare Profiles -->
      @if (canAccessTravelInsights()) {
        <div>
          <div class="menu-sub-item-header" routerLinkActive="menu-sub-item-selected" routerLink="/insights/travel">{{'global.sidenavMenu.insights.travel' | translate}}</div>
          @for (profile of  (permissionProfiles.get(Permission.canAccessInsightsPageTravel) ?? []); track profile) {
            <div>
              <div class="menu-sub-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/insights/travel/{{profile.customerProfileCode}}"><div class="profilename">{{profile.name}}</div></div>
            </div>
          }
        </div>
      }
      <!-- Mobility Profiles -->
      @if (canAccessMobilityInsights()) {
        <div>
          <div class="menu-sub-item-header" routerLinkActive="menu-sub-item-selected" routerLink="/insights/mobility">{{'global.sidenavMenu.insights.mobility' | translate}}</div>
          @for (profile of (permissionProfiles.get(Permission.canAccessInsightsPageMobility) ?? []); track profile) {
            <div>
              <div class="menu-sub-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/insights/mobility/{{profile.customerProfileCode}}">
                <div class="profilename">{{profile.name}}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <!-- Economy/Invoices -->
    @if (accountRoleService.isEconomyActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/economy">{{'global.sidenavMenu.economy.main' | translate}}</div>
    }
    <div class="menu-sub" [style.display]="isEconomyRouteActive() ? 'block' : 'none'">
      @if (canAccessTravelEconomy()) {
        <div class="menu-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/economy/travel">{{'global.sidenavMenu.economy.travel' | translate}}</div>
      }
      @if (canAccessMobilityEconomy()) {
        <div class="menu-sub-item" routerLinkActive="menu-sub-item-selected" routerLink="/economy/mobility">{{'global.sidenavMenu.economy.mobility' | translate}}</div>
      }
    </div>
    <!-- Products & Profiles -->
    @if (accountRoleService.isProductsAndContractsActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/products-contracts/products">{{'global.sidenavMenu.productsContracts' | translate}}</div>
    }
    <!-- Case Event Management -->
    @if (accountRoleService.isCaseEventManagementActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/case-events/api-key-management">{{'global.sidenavMenu.caseEventManagement' | translate}}</div>
    }
    <!-- Major Incidents -->
    @if (accountRoleService.isMajorIncidentsActive()) {
      <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/major-incidents">{{'global.sidenavMenu.majorIncidents' | translate}}</div>
    }
    <!-- Settings -->
    <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/settings/my-profile">{{'global.sidenavMenu.settings' | translate}}</div>
    <!-- Help & Contact -->
    <div class="menu-item" routerLinkActive="menu-item-selected" routerLink="/helpAndContact">{{'global.sidenavMenu.helpAndContact' | translate}}</div>
  </div>
}
<!-- Extranet -->
<div class="extranet">
  <a href="https://extranet.sos.dk" target="_blank" [ngbTooltip]="'Click here to go to SOS Extranet Travelcare to find cases in the old case management system' | translate">SOS Extranet Travelcare</a><br>
  <a href="https://extranet.sos.dk" target="_blank" [ngbTooltip]="'Click here to go to SOS Extranet Mobility' | translate">SOS Extranet Mobility</a>
</div>
